import { render, staticRenderFns } from "./SharePage.vue?vue&type=template&id=4c75d6d2"
import script from "./SharePage.vue?vue&type=script&lang=ts&setup=true"
export * from "./SharePage.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports